import React from "react";
import { COLORS } from "@app/constants";
import { Text, View } from "@/styles/reactnative";

interface IProps {
  name?: string;
  amount?: string;
  rate?: string;
}
const MarketTableTopHeader = ({ name, amount, rate }: IProps) => {
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <View style={{ width: "33.33%", alignItems: "flex-start" }}>
        <Text size={12} style={{ color: COLORS.lightGray }}>
          {name}
        </Text>
      </View>
      <View style={{ width: "33.33%" }}>
        <Text size={12} style={{ color: COLORS.lightGray }}>
          {amount}
        </Text>
      </View>
      <View style={{ width: "33.33%", alignItems: "flex-end" }}>
        <Text size={10} style={{ color: COLORS.lightGray }}>
          {rate}
        </Text>
      </View>
    </View>
  );
};

export default React.memo(MarketTableTopHeader);
